(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shipment-percentage"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const items = document.querySelectorAll(".shipment-item");
  items.forEach(item => {
    const percentage = item.dataset.percentage;
    const bar = item.querySelector(".shipment-bar");
    bar.style.width = percentage + "%";
  });
});

  } catch(e) { console.error(e); }
})();
})();
